export default function(model) {
    return (window.generalSettings._shouldUseUrlSlugs) ? model._urlSlug : model._id;
}